import FaqsData from "assets/files/Faqs.json"

export function GetFaqsData() {
    return FaqsData;
}